var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00042 5.143V16.2859C6.00042 16.7592 5.61666 17.143 5.14328 17.143C4.66989 17.143 4.28613 16.7592 4.28613 16.2859V5.143C4.28613 4.19622 5.05364 3.42871 6.00042 3.42871H15.429C15.9024 3.42871 16.2861 3.81247 16.2861 4.28585C16.2861 4.75924 15.9024 5.143 15.429 5.143H6.00042ZM8.57185 6.85728H18.8576C19.3309 6.85728 19.7147 7.24104 19.7147 7.71443V19.7144C19.7147 20.1878 19.3309 20.5716 18.8576 20.5716H8.57185C8.09846 20.5716 7.7147 20.1878 7.7147 19.7144V7.71443C7.7147 7.24104 8.09846 6.85728 8.57185 6.85728ZM9.42899 18.8573H18.0004V8.57157H9.42899V18.8573Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.73d4861e64f92f29d3691b1e5107e0d6.svg";
export { ForwardRef as ReactComponent };